import React from 'react'
import PendingHeader from './pendingHeader'
import RTRLegalScroll from './rtrLegalScroll'
import ThemeBadge from './theme-badge'
import { css } from 'lib/paypalphrodite'
import { connect } from 'transfer/utils/p2p-connect'
import classNames from 'classnames'
import { showGiftOptions } from '../../experiments/gift-options'
import { tracking } from '../../lib/analytics/mParticle'
import { getFeePayerTracking } from '../../lib/analytics/helper'
import Events from '../../lib/analytics/eventTags'
import { handleSuccessRedirect } from '../utils/pisp-utils'
import {
  shouldShowSuccessSendMoneySurvey,
  shouldShowAlternativeSuccessMessage,
} from '../../experiments/sendMoneySuccessSurvey'
import { QUALTRICS_APP_NAME, FLOW_TYPES } from '../constants'
import MGMEntryPointHeader from './mgm/mgmEntryPointHeader'

/**
 * Base success component which will be consumed by `connect`ed wrapper containers
 * that will grab necessary data to render the success page
 */
import PropTypes from 'prop-types'

import { genericPropType } from 'prop-validators'
import AppBanner from './app-banner'
import styles from './success-base.styles'
import content from 'pp-react-l10n'
import { isAppPushTreatment } from '../../experiments/appPush'
import AppPushModal from './app-push-modal/appPushModal'
import enRTRStrings from '../../../../config/enRTRStrings'
import {
  hasMgmSuccessScreenEntryPointTreatment,
  hasMgmSuccessScreenEntryPointTwoTreatment,
  hasMgmSuccessScreenEntryPointThreeTreatment,
} from 'experiments/mgm'
import { DoneXsell } from '@paypalcorp/growthuicomponents'
import { isDw2Repaint } from '../../experiments/dw2Repaint'
import {
  CaptionText,
  HeadingText,
  v2grey600,
  Button,
  BodyText,
  Link,
} from '@paypalcorp/pp-react'
import glamorous from 'glamorous'
import { mobileAndSmaller } from 'lib/styles/media-queries'
import { BOX_BORDER_STYLES } from 'lib/styles/styles'
let i18n = content('transfer/send/success')
const i18nPreview = content('transfer/page/preview')

const SuccessBoxDiv = glamorous.div({
  padding: '3.125rem',
  background: 'white',
  [mobileAndSmaller]: {
    padding: '1.125rem',
  },
  ...BOX_BORDER_STYLES,
})

const OrderBoxDiv = glamorous.div({
  paddingTop: '32px',
  paddingBottom: '32px',
})

export class SuccessBase extends React.Component {
  static propTypes = {
    recipient: PropTypes.string.isRequired,
    userState: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    showPPMeIframe: PropTypes.bool.isRequired,
    timeZone: PropTypes.string.isRequired,
    isOFAC: PropTypes.bool.isRequired,
    isRTR: PropTypes.bool.isRequired,
    ppmeClaimIframeComponent: genericPropType,
    rtrSuccessBreakdownComponent: genericPropType,
    isNativeApp: PropTypes.bool,
    successHeaderContent: PropTypes.string.isRequired,
    successHeaderTranslatedContent: PropTypes.string,
    successIatUnilateralHeader: PropTypes.string,
    successIatUnilateralSubheader: PropTypes.string,
    showThemeBadge: PropTypes.bool,
    showGiftBlurb: PropTypes.bool,
    themeId: PropTypes.string,
    canShowFirstTimeMessage: PropTypes.bool.isRequired,
    doneLinksComponent: genericPropType,
    transactionId: PropTypes.string,
    pageName: PropTypes.string,
    pageName2: PropTypes.string,
    showAppBanner: PropTypes.bool,
    isPPMe: PropTypes.bool,
    isPsd: PropTypes.bool,
    sessionID: PropTypes.string,
    isPurchase: PropTypes.bool,
    isMobile: PropTypes.bool,
    hasIatUnilateralDisclosure: PropTypes.bool,
    iatDelayedDebitDuration: PropTypes.string,
    suggestedDesign: PropTypes.string,
    recipientCountry: PropTypes.string,
    amount: PropTypes.string,
    originAmount: PropTypes.string,
    destinationAmount: PropTypes.string,
    currencyCode: PropTypes.string,
    fromCurrencyCode: PropTypes.string,
    moneyPageOverPanel: PropTypes.string,
    recipientAccountType: PropTypes.string,
    noteLength: PropTypes.number,
    showENSubTextRTR: PropTypes.bool,
    isMgm: PropTypes.bool,
    isUnilateral: PropTypes.bool,
    isPpcp: PropTypes.bool,
    amountFormatted: PropTypes.string,
    xsell: PropTypes.object,
    xsellDismissHandler: PropTypes.func,
    xsellDismissFptiData: PropTypes.object,
    xsellDismissUrl: PropTypes.string,
    orderId: PropTypes.string,
  }

  static defaultProps = {
    showPPMeIframe: false,
    isUnilateral: false,
    showThemeBadge: false,
    showGiftBlurb: false,
    themeId: '',
    canShowFirstTimeMessage: true,
  }

  componentDidMount() {
    const {
      amount,
      originAmount,
      destinationAmount,
      isMobile,
      suggestedDesign,
      recipientCountry,
      isPurchase,
      currencyCode,
      fromCurrencyCode,
      moneyPageOverPanel,
      recipientAccountType,
      noteLength,
      transactionId,
      isMgm,
    } = this.props
    if (isMobile) {
      window.scrollTo(0, 0)
    }

    let feedbackAvailable = 'control'

    if (shouldShowSuccessSendMoneySurvey()) {
      feedbackAvailable = 't1'
    } else if (shouldShowAlternativeSuccessMessage()) {
      feedbackAvailable = 't2'
    }

    tracking(
      Events.p2p_success_screen_shown({
        suggested_protection_design: suggestedDesign,
        receiver_country: recipientCountry || 'US',
        ...getFeePayerTracking(),
        payment_type: isPurchase ? 'purchase' : 'personal',
        receiver_amount_local_currency:
          currencyCode === fromCurrencyCode ? amount : destinationAmount,
        receiver_currency: currencyCode,
        sender_amount:
          currencyCode === fromCurrencyCode ? amount : originAmount,
        sender_currency: fromCurrencyCode,
        protection_design: moneyPageOverPanel,
        receiver_account_type: recipientAccountType,
        page_variant: 'p2p_existing',
        note_character_length: noteLength,
        txn_id: transactionId || '',
        feedback_available: feedbackAvailable,
        ...(isMgm ||
        hasMgmSuccessScreenEntryPointTreatment() ||
        hasMgmSuccessScreenEntryPointTwoTreatment() ||
        hasMgmSuccessScreenEntryPointThreeTreatment()
          ? { design_mgm: 'y' }
          : { design_mgm: 'n' }),
      })
    )
  }

  renderAppBanner() {
    const isAppPushTrmnt = isAppPushTreatment()

    // Do not render for partner flows
    if (this.props.isPsd) {
      return null
    }

    if (isAppPushTrmnt) {
      return <AppPushModal />
    }

    return (
      <AppBanner
        pageName={this.props.pageName}
        pageName2={this.props.pageName2}
      />
    )
  }

  handlePispCTARedirect = () => {
    const { transactionId } = this.props
    return handleSuccessRedirect(transactionId)
  }

  openQualtricsForm = () => {
    tracking(Events.p2p_success_screen_feedback_pressed({}))
    if (typeof window.PAYPAL !== 'undefined' && window.PAYPAL.analytics) {
      window.PAYPAL.analytics.reloadQualtrics(QUALTRICS_APP_NAME)
    }
  }

  renderQualtrics = recipient => {
    if (this.props.isPpcp) {
      return null
    }

    if (shouldShowAlternativeSuccessMessage()) {
      return isDw2Repaint() ? (
        <>
          <BodyText>
            {i18n('success.finalMessageTextSeparated', { recipient })}
          </BodyText>
          <Button
            tertiary={true}
            type="button"
            onClick={this.openQualtricsForm}
          >
            {i18n('success.qualtricsLinkTextSeparated')}
          </Button>
        </>
      ) : (
        <div>
          <p>{i18n('success.finalMessageTextSeparated', { recipient })}</p>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a onClick={this.openQualtricsForm} href="#">
            {i18n('success.qualtricsLinkTextSeparated')}
          </a>
        </div>
      )
    } else if (shouldShowSuccessSendMoneySurvey()) {
      return isDw2Repaint() ? (
        <>
          <BodyText>{i18n('success.finalMessageText', { recipient })}</BodyText>
          <Button
            tertiary={true}
            type="button"
            onClick={this.openQualtricsForm}
          >
            {i18n('success.quatricsLinkText')}
          </Button>
        </>
      ) : (
        <p>
          {i18n('success.finalMessageText', { recipient })}{' '}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a onClick={this.openQualtricsForm} href="#">
            {i18n('success.quatricsLinkText')}
          </a>
        </p>
      )
    }
  }

  render() {
    const headerClassNameList = classNames('successHeader', {
      rtrSuccessHeader: this.props.isRTR,
    })
    const giftBurpClassNames = classNames(
      css(styles.giftBlurb),
      {
        [css(styles.rtrGiftBlurb)]: this.props.isRTR,
      },
      'vx_text-6_lighter'
    )
    const displayName = this.props.displayName || this.props.recipient
    const hasSuccessMGMEntryPointDescription =
      hasMgmSuccessScreenEntryPointTwoTreatment() ||
      hasMgmSuccessScreenEntryPointThreeTreatment()

    const showDoneXsell =
      this.props.xsell &&
      !this.props.isOFAC &&
      !this.props.isMgm &&
      !this.props.isUnilateral &&
      !this.props.isRTR &&
      !this.props.isPsd &&
      !this.props.isPpcp

    return (
      <div className={`${css(styles.pageWrapper)} reactPage-success`}>
        {showDoneXsell ? (
          <>
            <div id="successTransactionId" style={{ display: 'none' }}>
              {this.props.transactionId}
            </div>
            <div
              className={`${css(styles.headerBox)} ${css(styles.xsellSuccess)}`}
            >
              <DoneXsell
                flow="default"
                content={this.props.xsell}
                isMobile={this.props.isMobile}
                amount={this.props.amountFormatted}
                recipientName={displayName}
                dismissHandler={this.props.xsellDismissHandler}
                dismissFptiData={this.props.xsellDismissFptiData}
                dismissUrl={this.props.xsellDismissUrl}
              />
            </div>
          </>
        ) : (
          <>
            {this.props.showAppBanner && this.renderAppBanner()}
            <div id="successTransactionId" style={{ display: 'none' }}>
              {this.props.transactionId}
            </div>
            <div className={css(styles.headerBox)}>
              {this.props.isOFAC && <PendingHeader />}
              {isDw2Repaint() ? (
                <div
                  style={{
                    ...((!this.props.isOFAC || this.props.showENSubTextRTR) && {
                      marginBottom: '1.5rem',
                    }),
                  }}
                >
                  {!this.props.isOFAC && (
                    <HeadingText size="sm" data-nemo="success-header">
                      {this.props.hasIatUnilateralDisclosure &&
                      !this.props.isMgm
                        ? this.props.successIatUnilateralHeader
                        : this.props.successHeaderContent}
                    </HeadingText>
                  )}
                  {this.props.showENSubTextRTR && (
                    <CaptionText style={{ color: v2grey600 }}>
                      {this.props.successHeaderTranslatedContent}
                    </CaptionText>
                  )}
                </div>
              ) : (
                <>
                  {!this.props.isOFAC && (
                    <h2
                      className={headerClassNameList}
                      data-nemo="success-header"
                    >
                      {' '}
                      {this.props.hasIatUnilateralDisclosure &&
                      !this.props.isMgm
                        ? this.props.successIatUnilateralHeader
                        : this.props.successHeaderContent}
                    </h2>
                  )}
                  {this.props.showENSubTextRTR && (
                    <h2 className={`${css(styles.successHeaderENSubText)}`}>
                      {this.props.successHeaderTranslatedContent}
                    </h2>
                  )}
                </>
              )}

              {this.props.orderId && (
                <OrderBoxDiv>
                  <BodyText className={`${css(styles.orderNumberText)}`}>
                    {i18n('success.orderNumberText')}
                  </BodyText>
                  <Link
                    className={`${css(styles.orderNumberLink)}`}
                    data-pagename="main:transaction:details:transaction"
                    href={`/myaccount/transaction/details/${this.props.transactionId}`}
                  >
                    {this.props.orderId}
                  </Link>
                </OrderBoxDiv>
              )}

              {!this.props.isMobile &&
                !this.props.isOFAC &&
                !this.props.isMgm &&
                !this.props.isUnilateral &&
                !this.props.isRTR &&
                !hasSuccessMGMEntryPointDescription &&
                this.renderQualtrics(displayName)}

              {!this.props.isOFAC &&
                this.props.hasIatUnilateralDisclosure &&
                !this.props.isMgm &&
                (isDw2Repaint() ? (
                  <div data-nemo="success-subheader">
                    <BodyText>
                      {this.props.hasIatUnilateralDisclosure
                        ? this.props.successIatUnilateralSubheader
                        : ''}
                    </BodyText>
                  </div>
                ) : (
                  <p
                    className={`${css(styles.successSubheader)} vx_text-3`}
                    data-nemo="success-subheader"
                  >
                    {this.props.hasIatUnilateralDisclosure
                      ? this.props.successIatUnilateralSubheader
                      : ''}
                  </p>
                ))}

              {!this.props.isOFAC &&
                this.props.isMgm &&
                (isDw2Repaint() ? (
                  <div
                    style={{ marginBottom: '1rem' }}
                    data-nemo="success-subheader"
                  >
                    <BodyText>{i18n('success.mgmDescFirst')}</BodyText>
                    <BodyText>{i18n('success.mgmDescSecond')}</BodyText>
                  </div>
                ) : (
                  <p
                    className={`${css(styles.successMgmSubheader)} vx_text-3`}
                    data-nemo="success-subheader"
                  >
                    {i18n('success.mgmDescFirst')}
                    <div className={`${css(styles.successMgmSubheaderLine)}`}>
                      {i18n('success.mgmDescSecond')}
                    </div>
                  </p>
                ))}

              {!this.props.isOFAC && !this.props.isRTR && !this.props.isMgm && (
                <MGMEntryPointHeader timeZone={this.props.timeZone} />
              )}

              {this.props.isRTR && this.props.rtrSuccessBreakdownComponent}

              {this.props.showThemeBadge &&
                !this.props.isOFAC &&
                !showGiftOptions() && (
                  <ThemeBadge
                    selectedThemeId={this.props.themeId}
                    disableClick={true}
                  />
                )}
              {this.props.showGiftBlurb && !this.props.isOFAC && (
                <>
                  <p className={giftBurpClassNames}>
                    {i18n('gift.blurb', {
                      displayName,
                    })}
                  </p>
                  {this.props.showENSubTextRTR && (
                    <p
                      className={`${css(
                        styles.giftBlurbENSubText
                      )} vx_text-6_lighter`}
                    >
                      {enRTRStrings.giftBlurb[0]} {displayName}{' '}
                      {enRTRStrings.giftBlurb[1]}
                    </p>
                  )}
                </>
              )}
            </div>
            {this.props.isPsd ? (
              <div className={`${css(styles.doneButtonContainer)}`}>
                <button
                  className={`vx_btn done ${css(styles.doneButton)}`}
                  onClick={this.handlePispCTARedirect}
                >
                  {i18nPreview('input.continue')}
                </button>
              </div>
            ) : (
              !this.props.xsell && this.props.doneLinksComponent
            )}
            {this.props.isRTR &&
              (isDw2Repaint() ? (
                <SuccessBoxDiv data-nemo="rtr-success-box">
                  <RTRLegalScroll {...this.props} />
                </SuccessBoxDiv>
              ) : (
                <div
                  className="successBox rtrSuccessBox"
                  data-nemo="rtr-success-box"
                >
                  <RTRLegalScroll {...this.props} />
                </div>
              ))}
          </>
        )}
      </div>
    )
  }
}

export default connect(
  ({ server, user, transaction, crossBorder, recipient, amount, note }) => ({
    timeZone: user.timeZone,
    isMobile: server.isMobile,
    isPPMe: server.env === 'ppme',
    isPsd: server.env === 'pisp',
    sessionID: server.sessionID,
    isPurchase: transaction.isPurchase,
    suggestedDesign: recipient.suggestedDesign,
    recipientCountry: recipient.country,
    transactionId: transaction.paymentDetails.payment_id,
    recipientAccountType: recipient.recipientAccountType,
    moneyPageOverPanel: recipient.moneyPageOverPanel,
    destinationAmount: crossBorder.destinationAmount,
    originAmount: crossBorder.originAmount,
    amount: amount.amount,
    currencyCode: amount.currencyCode,
    fromCurrencyCode: amount.fromCurrencyCode,
    noteLength: note.note.length,
    isMgm: server.isMgm,
    isUnilateral: !recipient.isPaypalAccount,
    isPpcp: server.env === 'hawk-ppcp',
    orderId:
      server.env === FLOW_TYPES.PPSHOPS
        ? transaction.paymentDetails.order_id
        : '',
  })
)(SuccessBase)
